import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Document from './components/Document';
import DocumentList from './components/DocumentList';
import DocumentUpdate from './components/DocumentUpdate';

ReactDOM.render(
  <BrowserRouter>
    <div>
      <Switch>
        <Route exact path="/" component={DocumentList} />
        <Route exact path="/add-document" component={Document} />
        <Route exact path="/update-document/:documentNumber" component={DocumentUpdate} />
      </Switch>
    </div>
  </BrowserRouter>,
  document.getElementById('root')
);
//registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js